var config = {
  supportEmail: 'ccbhelp@hms.harvard.edu',
  pipelineVersionToRerunQC: 1,
  workerVersion: 4 // needs to match workerVersion in API
};

export default config;